/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { UIChart } from 'primeng/chart';
import { LANGUAGES } from 'src/app/conf/languages';
import { AccessoryPower, BoardPower } from 'src/app/model/device-bus';
import { AppState } from 'src/app/store/app.reducer';
import * as UserActions from 'src/app/store/user/user.actions';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import { Observable, Subscription } from 'rxjs';
import { User } from 'src/app/model/user';
import { selectUser } from 'src/app/store/user/user.selector';
import { StandardPageLayout } from '../shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-green-power',
	templateUrl: './green-power.component.html',
})

export class GreenPowerComponent implements OnInit, OnDestroy {
	@ViewChild('total') chart: UIChart;

	user$: Observable<User | undefined>;
	userSub: Subscription | undefined;

	enableGreenPower: boolean;

	listBus: BoardPower[];
	busSelect: BoardPower | undefined;

	listGateway: AccessoryPower[];
	listFotocelluleBus: AccessoryPower[];
	listSelettoriBus: AccessoryPower[];
	listInterfaccieBus: AccessoryPower[];
	listLampeggiantiBus: AccessoryPower[];
	listFotocell: AccessoryPower[];
	listSelR: AccessoryPower[];
	listSchede: AccessoryPower[];
	valuePower = [
		{ color: '#34d399', value: 16 },
		{ color: '#fbbf24', value: 8 },
		{ color: '#60a5fa', value: 24 },
		{ color: '#c084fc', value: 10 }
	];
	valueGreenPower = [
		{ color: '#34d399', value: 16 },
		{ color: '#fbbf24', value: 8 },
		{ color: '#60a5fa', value: 24 },
		{ color: '#c084fc', value: 10 }
	];
	valueCalcPower = [
		{ color: '#34d399', value: 16 },
		{ color: '#fbbf24', value: 8 },
		{ color: '#60a5fa', value: 24 },
		{ color: '#c084fc', value: 10 }
	];


	maxPower: number;
	maxPowerBus: number;

	maxGateway: number;
	maxSchede: number;
	maxFotocelluleBus: number;
	maxSelettoriBus: number;
	maxInterfaccieBus: number;
	maxLampeggiantiBus: number;
	maxFotocelluleOld: number;
	maxSelettoriOld: number;

	totalBoard: number;
	totalSchede: number;
	totalGateway: number;
	totalFotocelluleBus: number;
	totalSelettoriBus: number;
	totalInterfaccieBus: number;
	totalLampeggiantiBus: number;
	totalFotocelluleOld: number;
	totalSelettoriOld: number;

	totalLoadBoard: number;
	totalLoadGateway: number;
	totalLoadSchede: number;
	totalLoadFotocelluleBus: number;
	totalLoadSelettoriBus: number;
	totalLoadInterfaccieBus: number;
	totalLoadLampeggiantiBus: number;
	totalLoadFotocelluleOld: number;
	totalLoadSelettoriOld: number;
	totalPower: number;
	totalPowerBus: number;


	totalLoadBoardPercentage: number;
	totalLoadGatewayPercentage: number;
	totalLoadSchedePercentage: number;
	totalLoadFotocelluleBusPercentage: number;
	totalLoadSelettoriBusPercentage: number;
	totalLoadInterfaccieBusPercentage: number;
	totalLoadLampeggiantiBusPercentage: number;
	totalLoadFotocelluleOldPercentage: number;
	totalLoadSelettoriOldPercentage: number;
	totalLoadBusPercentage: number;

	ZN7 = new BoardPower(1, 'ZN7', 40, 0.5, true, 5, 0.3, 2, 0,
		1, 1, 0, 0, 0, 0, 8, 2, 2);
	ZBX7N = new BoardPower(2, 'ZBX7N', 20, 0.5, true, 5, 0.3, 2, 0,
		1, 1, 0, 0, 0, 0, 8, 2, 2);
	ZL57 = new BoardPower(3, 'ZL57', 40, 0.8, true, 5, 0.3, 2, 0,
		1, 1, 0, 0, 0, 0, 8, 2, 2);
	ZLX24 = new BoardPower(4, 'ZLX24', 40, 0.5, true, 3, 0.3, 2, 15,
		1, 1, 8, 8, 2, 2, 8, 0, 2);
	ZLX230 = new BoardPower(5, 'ZLX230', 12, 0.8, true, 0.8, 0.3, 0, 15,
		1, 1, 8, 8, 2, 2, 8, 0, 2);



	browserDeviceScreen = 960;

	visibleCameInfo = true;


	totalChart: any;
	totalOptions: any;

	guest = true;

	/*doughnutChartLabels: Label[] = [];
	doughnutChartData: MultiDataSet = [[]];
	doughnutChartType: ChartType = 'doughnut';
	colors: Color[] = [{backgroundColor: ['orange', 'green', 'blue', 'pink', 'grey']}];*/

	// design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MIN_MD_WIDTH_EXT = 670;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_COL4 = 1530;
	MIN_WIDTH_MX7 = 1700;

	doughnutChartOptions = {
		legend: {
			display: true,
			position: 'bottom',
			onClick: (e) => e.stopPropagation(),
		},
		tooltips: {
			callbacks: {
				label: (tooltipItem) => this.tooltips(tooltipItem),
				title: () => null,
			}
		},
	};

	constructor(
		private route: ActivatedRoute,
		private translate: TranslateService,
		private store: Store<AppState>
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.user$ = this.store.select(selectUser);
	}

	ngOnDestroy(): void {
		this.userSub?.unsubscribe();
	}

	ngOnInit() {
		this.enableGreenPower = false;
		this.userSub = this.user$?.subscribe(currentUser => {
			if (currentUser !== undefined && currentUser.Email !== undefined && currentUser.Email !== '') {
				this.guest = false;
			}
		});
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'BUS_PAGE_TITLE'
		}));
		const lang = this.route.snapshot.queryParamMap.get('language');
		const langVal = LANGUAGES.find(l => l.code === lang);
		if (langVal !== undefined) {
			this.store.dispatch(UserActions.setCurrentLang({ lang: langVal }));
			if (langVal.code !== this.translate.currentLang && localStorage != null) {
				window.location.reload();
			}
		}

		/*const doughnutChartLabels = [this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalFotocelluleBus + '): ' + this.totalLoadFotocelluleBusPercentage + '%'];
		doughnutChartLabels.push(this.translate.instant('BUS_SELECTORS') + ' (' + this.totalSelettoriBus + '): ' + this.totalLoadSelettoriBusPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_INTERFACES') + ' (' + this.totalInterfaccieBus + '): ' + this.totalLoadInterfaccieBusPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_FLASHING') + ' (' + this.totalLampeggiantiBus + '): ' + this.totalLoadLampeggiantiBusPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_AVAILABLE') + ': ' + 100 + '%');

		const documentStyle = getComputedStyle(document.documentElement);

		this.totalChart = {
			labels: doughnutChartLabels,
			datasets: [
				{
					// label: [this.translate.instant('BUS_PHOTOCELLS'),'BUS_SELECTORS','BUS_INTERFACES','BUS_FLASHING','BUS_AVAILABLE'],
					data: [0, 0, 0, 0, 100],
					backgroundColor: [documentStyle.getPropertyValue('--yellow-600'), documentStyle.getPropertyValue('--green-600'), documentStyle.getPropertyValue('--blue-600'), documentStyle.getPropertyValue('--purple-600'), documentStyle.getPropertyValue('--blueGrey-600')],
					borderWidth: 0,
				},
			],
		};*/

		this.totalOptions = {
			plugins: {
				legend: {
					display: false,
				},
			},
			responsive: true,
			cutout: '60%',
			animation: false
		};

		this.browserDeviceScreen = window.screen.width;
		this.listBus = [];
		this.listBus.push(this.ZN7);
		this.listBus.push(this.ZBX7N);
		this.listBus.push(this.ZL57);
		this.listBus.push(this.ZLX24);
		//this.listBus.push(this.ZLX230);
		this.busSelect = this.listBus[0];

		this.listGateway = [];
		this.listGateway.push(new AccessoryPower(1, 'Gateway', 'BUS_CAME_KEY', 0.7, 0.7, 8,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listGateway.push(new AccessoryPower(2, 'Gateway', 'BUS_GATEWAY_WIFI', 1, 1, 8,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listGateway.push(new AccessoryPower(3, 'Gateway', 'BUS_SLAVE', 0.5, 0.5, 8,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listGateway.push(new AccessoryPower(4, 'Gateway', 'BUS_RGSM', 4, 4, 8,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listGateway.push(new AccessoryPower(4, 'Gateway', 'BUS_GATEWAY_4G', 4, 4, 8,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));

		this.listFotocelluleBus = [];
		this.listFotocelluleBus.push(new AccessoryPower(1, 'Fotocellule Bus', 'BUS_CALC_PHO_DLX_BUS_DXR_BUS', 0.35, 0.35, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		/*this.listFotocelluleBus.push(new AccessoryPower(2, 'Fotocellule Bus', 'BUS_CALC_PHO_DXR_BUS', 0.35, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));*/

		this.listSelettoriBus = [];
		this.listSelettoriBus.push(new AccessoryPower(1, 'Selettori Bus', 'BUS_CALC_SEL_KEYPAD', 0.35, 0.35, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listSelettoriBus.push(new AccessoryPower(2, 'Selettori Bus', 'BUS_CALC_SEL_RFID_TRA', 0.35, 0.35, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listSelettoriBus.push(new AccessoryPower(3, 'Selettori Bus', 'BUS_CALC_SEL_MIFARE_TRA', 1, 1, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listSelettoriBus.push(new AccessoryPower(4, 'Selettori Bus', 'BUS_CALC_SEL_BLE', 1, 1, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listSelettoriBus.push(new AccessoryPower(5, 'Selettori Bus', 'BUS_CALC_SEL_KEY_SEL', 0.35, 0.35, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));

		this.listInterfaccieBus = [];
		this.listInterfaccieBus.push(new AccessoryPower(1, 'Interfacce Bus', 'BUS_CALC_INT_MODULE', 0.35, 0.35, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));

		this.listLampeggiantiBus = [];
		this.listLampeggiantiBus.push(new AccessoryPower(1, 'Lampeggianti Bus', 'BUS_CALC_FLA_KRX', 3.5, 3.5, 0,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listLampeggiantiBus.push(new AccessoryPower(2, 'Lampeggianti Bus', 'BUS_CALC_FLA_GW_KRX', 5, 5, 0,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));


		this.listSchede = [];
		this.listSchede.push(new AccessoryPower(1, 'Schede', 'BUS_AF43S_AF868', 0, 0, 0,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listSchede.push(new AccessoryPower(2, 'Schede', 'BUS_RIO', 0.2, 0.2, 0,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listSchede.push(new AccessoryPower(3, 'Schede', 'BUS_R700', 0.4, 0.4, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listSchede.push(new AccessoryPower(4, 'Schede', 'BUS_R800', 0.3, 0.3, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listSchede.push(new AccessoryPower(5, 'Schede', 'BUS_RCXN', 0.3, 0.3, 0,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));

		this.listSelR = [];
		this.listSelR.push(new AccessoryPower(1, 'Selettori', 'BUS_KEYPAD', 0.3, 0.3, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));
		this.listSelR.push(new AccessoryPower(2, 'Selettori', 'BUS_TRASPONDER', 0.4, 0.4, 2,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));


		this.listFotocell = [];
		this.listFotocell.push(new AccessoryPower(1, 'Fotocellule', 'BUS_DIR_DLX_DELTA_DXR', 0.1, 0.1, 0,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));

		this.busChange();

		this.translate.onLangChange.subscribe(() => {
			this.changeLegends();
		});

		/*this.totalLoadFotocellule.subscribe(() => {
			this.doughnutChartLabels = [];
			this.doughnutChartLabels.push(this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalLoadFotocellule +') ');
			this.doughnutChartLabels.push(this.translate.instant('BUS_SELECTORS'));
			this.doughnutChartLabels.push(this.translate.instant('BUS_INTERFACES'));
			this.doughnutChartLabels.push(this.translate.instant('BUS_FLASHING'));
			this.doughnutChartLabels.push(this.translate.instant('BUS_AVAILABLE'));
		});*/

		const visibleCameInfoParam = this.route.snapshot.queryParamMap.get('cameInfo');
		if (visibleCameInfoParam != null && visibleCameInfoParam === 'false') {
			this.visibleCameInfo = false;
		}

		this.onResize();
	}

	resetForm(): void {
		this.maxPower = this.busSelect.maxPower;
		this.maxPowerBus = this.busSelect.cxn;
		if (this.enableGreenPower) {
			this.totalPower = this.busSelect.powerGreen;
		} else {
			this.totalPower = this.busSelect.power;
		}
		// MAX DEVICE
		this.maxGateway = this.busSelect.maxGateway;
		this.maxSchede = this.busSelect.maxSchede;
		this.maxFotocelluleBus = this.busSelect.maxFotocelluleBus;
		this.maxSelettoriBus = this.busSelect.maxSelettoriBus;
		this.maxInterfaccieBus = this.busSelect.maxInterfaccieBus;
		this.maxLampeggiantiBus = this.busSelect.maxLampeggiantiBus;
		this.maxFotocelluleOld = this.busSelect.maxFotocelluleOld;
		this.maxSelettoriOld = this.busSelect.maxSelettoriOld;
		// MAX DEVICE

		for (const device of this.listGateway) {
			device.quantity = 0;
		}
		for (const device of this.listFotocelluleBus) {
			device.quantity = 0;
		}
		for (const device of this.listSelettoriBus) {
			device.quantity = 0;
		}
		for (const device of this.listInterfaccieBus) {
			device.quantity = 0;
		}
		for (const device of this.listLampeggiantiBus) {
			device.quantity = 0;
		}
		for (const device of this.listSelR) {
			device.quantity = 0;
		}
		for (const device of this.listFotocell) {
			device.quantity = 0;
		}
		this.totalSchede = 0;
		this.totalGateway = 0;
		this.totalFotocelluleBus = 0;
		this.totalSelettoriBus = 0;
		this.totalInterfaccieBus = 0;
		this.totalLampeggiantiBus = 0;
		this.totalSelettoriOld = 0;
		this.totalFotocelluleOld = 0;

		this.totalLoadSchede = 0;
		this.totalLoadGateway = 0;
		this.totalLoadFotocelluleBus = 0;
		this.totalLoadSelettoriBus = 0;
		this.totalLoadInterfaccieBus = 0;
		this.totalLoadLampeggiantiBus = 0;
		this.totalLoadFotocelluleOld = 0;
		this.totalLoadSelettoriOld = 0;


		this.totalLoadBusPercentage = 0;
		this.totalLoadGatewayPercentage = 0;
		this.totalLoadFotocelluleBusPercentage = 0;
		this.totalLoadSelettoriBusPercentage = 0;
		this.totalLoadInterfaccieBusPercentage = 0;
		this.totalLoadLampeggiantiBusPercentage = 0;
		this.totalLoadFotocelluleOldPercentage = 0;
		this.totalLoadSelettoriOldPercentage = 0;

		this.calculateDisabledAddDevice();
	}

	resetFormGateway(): void {
		for (const device of this.listFotocelluleBus) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listSelettoriBus) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listInterfaccieBus) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listLampeggiantiBus) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listFotocell) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}

		for (const device of this.listSelR) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}


	}

	changeLegends(): void {
		/*const available = this.busSelect.cxn-this.totalLoadBus;
		const availablePercentage = 100 - this.totalLoadBusPercentage;*/
	}

	busChange(): void {
		this.resetForm();
		this.calculateDisabledAddDevice();
	}

	tooltips(tooltipItem: any): string {
		//const available = this.busSelect.cxn-this.totalLoadBus;
		const availablePercentage = 100 - this.totalLoadBusPercentage;
		switch (tooltipItem.index) {
			case 0: {
				return this.translate.instant('BUS_BOARD') + ' (' + this.totalSchede + '): ' + this.totalLoadSchedePercentage + '%';
			}
			case 1: {
				return this.translate.instant('GATEWAY') + ' (' + this.totalGateway + '): ' + this.totalLoadGatewayPercentage + '%';
			}
			case 2: {
				return this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalFotocelluleBus + '): ' + this.totalLoadFotocelluleBusPercentage + '%';
			}
			case 3: {
				return this.translate.instant('BUS_SELECTORS') + ' (' + this.totalSelettoriBus + '): ' + this.totalLoadSelettoriBusPercentage + '%';
			}
			case 4: {
				return this.translate.instant('BUS_INTERFACES') + ' (' + this.totalInterfaccieBus + '): ' + this.totalLoadInterfaccieBusPercentage + '%';
			}
			case 5: {
				return this.translate.instant('BUS_FLASHING') + ' (' + this.totalLampeggiantiBus + '): ' + this.totalLoadLampeggiantiBusPercentage + '%';
			}
			case 6: {
				return this.translate.instant('BUS_AVAILABLE') + ': ' + availablePercentage + '%';
			}
		}
		return '-';
	}

	checkSelectable(device: AccessoryPower) {
		if (device.listBusActive.includes(this.busSelect.id)) {
			return false;
		}
		return true;
	}

	subtractOne(device: AccessoryPower) {
		if (device.quantity > 0) {
			device.quantity--;
			//this.totalPower = Number((this.totalPower - device.power).toFixed(2));
			switch (device.family) {
				case 'Gateway': {
					this.totalLoadGateway = Number((this.totalLoadGateway - device.power).toFixed(2));
					this.totalGateway--;
					break;
				} case 'Schede': {
					this.totalLoadSchede = Number((this.totalLoadSchede - device.power).toFixed(2));
					this.totalSchede--;
					break;
				}
				case 'Fotocellule Bus': {
					this.totalLoadFotocelluleBus = Number((this.totalLoadFotocelluleBus - device.power).toFixed(2));
					this.totalFotocelluleBus--;
					break;
				}
				case 'Selettori Bus': {
					this.totalLoadSelettoriBus = Number((this.totalLoadSelettoriBus - device.power).toFixed(2));
					this.totalSelettoriBus--;
					break;
				}
				case 'Interfacce Bus': {
					this.totalLoadInterfaccieBus = Number((this.totalLoadInterfaccieBus - device.power).toFixed(2));
					this.totalInterfaccieBus--;
					break;
				}
				case 'Lampeggianti Bus': {
					this.totalLoadLampeggiantiBus = Number((this.totalLoadLampeggiantiBus - device.power).toFixed(2));
					this.totalLampeggiantiBus--;
					break;
				}
				case 'Fotocellule': {
					this.totalLoadFotocelluleOld = Number((this.totalLoadFotocelluleOld - device.power).toFixed(2));
					this.totalFotocelluleOld--;
					break;
				}
				case 'Selettori': {
					this.totalLoadSelettoriOld = Number((this.totalLoadSelettoriOld - device.power).toFixed(2));
					this.totalSelettoriOld--;
					break;
				}
			}
			if (this.enableGreenPower && device.family === 'Gateway') {
				this.resetFormGateway();
			}
		}
		this.calculateDisabledAddDevice();
	}

	addOne(device: AccessoryPower) {
		device.quantity++;
		//this.totalPower = Number((this.totalPower + device.power).toFixed(2));
		switch (device.family) {
			case 'Gateway': {
				this.totalLoadGateway = Number((this.totalLoadGateway + device.power).toFixed(2));
				this.totalGateway++;
				break;
			}
			case 'Schede': {
				this.totalLoadSchede = Number((this.totalLoadSchede + device.power).toFixed(2));
				this.totalSchede++;
				break;
			}
			case 'Fotocellule Bus': {
				this.totalLoadFotocelluleBus = Number((this.totalLoadFotocelluleBus + device.power).toFixed(2));
				this.totalFotocelluleBus++;
				break;
			}
			case 'Selettori Bus': {
				this.totalLoadSelettoriBus = Number((this.totalLoadSelettoriBus + device.power).toFixed(2));
				this.totalSelettoriBus++;
				break;
			}
			case 'Interfacce Bus': {
				this.totalLoadInterfaccieBus = Number((this.totalLoadInterfaccieBus + device.power).toFixed(2));
				this.totalInterfaccieBus++;
				break;
			}
			case 'Lampeggianti Bus': {
				this.totalLoadLampeggiantiBus = Number((this.totalLoadLampeggiantiBus + device.power).toFixed(2));
				this.totalLampeggiantiBus++;
				break;
			}
			case 'Fotocellule': {
				this.totalLoadFotocelluleOld = Number((this.totalLoadFotocelluleOld + device.power).toFixed(2));
				this.totalFotocelluleOld++;
				break;
			}
			case 'Selettori': {
				this.totalLoadSelettoriOld = Number((this.totalLoadSelettoriOld + device.power).toFixed(2));
				this.totalSelettoriOld++;
				break;
			}
		}
		this.calculateDisabledAddDevice();
	}

	calculateDisabledAddDevice(): void {
		this.maxPower = this.busSelect.maxPower;
		this.maxPowerBus = this.busSelect.cxn;
		this.totalBoard = this.busSelect.power;
		/*for (const bus of this.listBus) {
			bus.disableAdd = this.totalLoadBus > bus.power;
		}*/

		if (this.enableGreenPower) {
			this.totalBoard = this.busSelect.powerGreen;
			this.maxPower = this.busSelect.limitGreenPower;
			for (const device of this.listGateway) {
				if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPower < device.limitGreenPower) {
					this.maxPower = device.limitGreenPower;
					this.totalBoard = this.busSelect.power;
				}
			}
			for (const device of this.listSchede) {
				if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPower < device.limitGreenPower) {
					this.maxPower = device.limitGreenPower;
				}
			}
			for (const device of this.listSelettoriBus) {
				if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPower < device.limitGreenPower) {
					this.maxPower = device.limitGreenPower;
				}
			}
			for (const device of this.listFotocelluleBus) {
				if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPower < device.limitGreenPower) {
					this.maxPower = device.limitGreenPower;
				}
			}
			for (const device of this.listInterfaccieBus) {
				if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPower < device.limitGreenPower) {
					this.maxPower = device.limitGreenPower;
				}
			}
			for (const device of this.listSelR) {
				if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPower < device.limitGreenPower) {
					this.maxPower = device.limitGreenPower;
				}
			}
			for (const device of this.listFotocell) {
				if (device.quantity > 0 && device.limitGreenPower > 0 && this.maxPower < device.limitGreenPower) {
					this.maxPower = device.limitGreenPower;
				}
			}
		}

		this.totalPower = Number((this.totalBoard + this.totalLoadSchede + this.totalLoadGateway + this.totalLoadSelettoriBus + this.totalLoadFotocelluleBus + this.totalLoadLampeggiantiBus +
			this.totalLoadInterfaccieBus + this.totalLoadSelettoriOld + this.totalLoadFotocelluleOld).toFixed(2));
		this.totalPowerBus = Number((this.totalLoadSelettoriBus + this.totalLoadFotocelluleBus + this.totalLoadLampeggiantiBus +
			this.totalLoadInterfaccieBus).toFixed(2));
		const delta = this.maxPower - this.totalPower;
		const deltaBus = this.maxPowerBus - this.totalPowerBus;
		for (const gateway of this.listGateway) {
			if (this.enableGreenPower) {
				gateway.disableAdd = this.totalGateway === this.maxGateway || gateway.power + this.busSelect.power > gateway.limitGreenPower;
				gateway.disableRemove = gateway.quantity === 0;
			} else {
				gateway.disableAdd = gateway.power >= delta || this.totalGateway === this.maxGateway;
				gateway.disableRemove = gateway.quantity === 0;
			}
		}
		for (const scheda of this.listSchede) {
			if (scheda.id === 1) {// Custom for BUS_AF43S_AF868
				scheda.disableAdd = scheda.power > delta || scheda.quantity > 0;
			} else if (scheda.id === 2) {// Custom for BUS_RIO
				scheda.disableAdd = scheda.power > delta || scheda.quantity > 0;
			} else if (scheda.id === 3) {// Custom for BUS_R700
				const find = this.listSchede.find(sc => sc.id === 4);
				if (this.enableGreenPower) {
					scheda.disableAdd = scheda.limitGreenPower - this.totalPower <= scheda.power || scheda.quantity > 0 || find.quantity > 0;
				} else {
					scheda.disableAdd = scheda.power >= delta || scheda.quantity > 0 || find.quantity > 0;
				}
			} else if (scheda.id === 4) {// Custom for BUS_R800
				const find = this.listSchede.find(sc => sc.id === 3);
				if (this.enableGreenPower) {
					scheda.disableAdd = scheda.limitGreenPower - this.totalPower <= scheda.power || scheda.quantity > 0 || find.quantity > 0;
				} else {
					scheda.disableAdd = scheda.power >= delta || scheda.quantity > 0 || find.quantity > 0;
				}
			} else if (scheda.id === 5) {// Custom for BUS_RCXN
				scheda.disableAdd = scheda.power > delta || scheda.quantity > 0 || this.busSelect.id !== 5; //ZLX230
			}
			scheda.disableRemove = scheda.quantity === 0;
		}
		for (const fotocellula of this.listFotocelluleBus) {
			if (this.enableGreenPower && fotocellula.limitGreenPower > 0) {
				fotocellula.disableAdd = fotocellula.limitGreenPower - this.totalPower < fotocellula.power || this.totalFotocelluleBus === this.maxFotocelluleBus || fotocellula.power > deltaBus;
				fotocellula.disableRemove = fotocellula.quantity === 0;
			} else {
				fotocellula.disableAdd = fotocellula.power > delta || this.totalFotocelluleBus === this.maxFotocelluleBus || fotocellula.power > deltaBus;
				fotocellula.disableRemove = fotocellula.quantity === 0;
			}
		}
		for (const selettore of this.listSelettoriBus) {
			if (this.enableGreenPower && selettore.limitGreenPower > 0) {
				let limitGreenPower = this.maxPower;
				if (selettore.limitGreenPower > limitGreenPower) {
					limitGreenPower = selettore.limitGreenPower;
				}
				selettore.disableAdd = limitGreenPower - this.totalPower <= selettore.power || this.totalSelettoriBus === this.maxSelettoriBus || selettore.power > deltaBus;
				selettore.disableRemove = selettore.quantity === 0;
			} else {
				selettore.disableAdd = selettore.power >= delta || this.totalSelettoriBus === this.maxSelettoriBus || selettore.power > deltaBus;
				selettore.disableRemove = selettore.quantity === 0;
			}
		}
		for (const interfaccia of this.listInterfaccieBus) {
			if (this.enableGreenPower && interfaccia.limitGreenPower > 0) {
				let limitGreenPower = this.maxPower;
				if (interfaccia.limitGreenPower > limitGreenPower) {
					limitGreenPower = interfaccia.limitGreenPower;
				}
				interfaccia.disableAdd = limitGreenPower - this.totalPower <= interfaccia.power || this.totalInterfaccieBus === this.maxInterfaccieBus || interfaccia.power > deltaBus
				interfaccia.disableRemove = interfaccia.quantity === 0;
			} else {
				interfaccia.disableAdd = interfaccia.power >= delta || this.totalInterfaccieBus === this.maxInterfaccieBus || interfaccia.power > deltaBus;
				interfaccia.disableRemove = interfaccia.quantity === 0;
			}
		}
		for (const lampeggiante of this.listLampeggiantiBus) {
			if (this.enableGreenPower && lampeggiante.limitGreenPower > 0) {
				let limitGreenPower = this.maxPower;
				if (lampeggiante.limitGreenPower > limitGreenPower) {
					limitGreenPower = lampeggiante.limitGreenPower;
				}
				lampeggiante.disableAdd = limitGreenPower - this.totalPower <= lampeggiante.power || this.totalLampeggiantiBus === this.maxLampeggiantiBus || lampeggiante.power > deltaBus;
				lampeggiante.disableRemove = lampeggiante.quantity === 0;
			} else {
				lampeggiante.disableAdd = lampeggiante.power >= delta || this.totalLampeggiantiBus === this.maxLampeggiantiBus || lampeggiante.power > deltaBus;
				lampeggiante.disableRemove = lampeggiante.quantity === 0;
			}
		}
		for (const fotocellula of this.listFotocell) {
			if (this.enableGreenPower && fotocellula.limitGreenPower > 0) {
				let limitGreenPower = this.maxPower;
				if (fotocellula.limitGreenPower > limitGreenPower) {
					limitGreenPower = fotocellula.limitGreenPower;
				}
				fotocellula.disableAdd = limitGreenPower - this.totalPower <= fotocellula.power || this.totalFotocelluleOld === this.maxFotocelluleOld;
				fotocellula.disableRemove = fotocellula.quantity === 0;
			} else {
				fotocellula.disableAdd = fotocellula.power >= delta || this.totalFotocelluleOld === this.maxFotocelluleOld;
				fotocellula.disableRemove = fotocellula.quantity === 0;
			}
		}
		for (const selettore of this.listSelR) {
			if (this.enableGreenPower && selettore.limitGreenPower > 0) {
				let limitGreenPower = this.maxPower;
				if (selettore.limitGreenPower > limitGreenPower) {
					limitGreenPower = selettore.limitGreenPower;
				}
				selettore.disableAdd = limitGreenPower - this.totalPower <= selettore.power || this.totalSelettoriOld === this.maxSelettoriOld;
				selettore.disableRemove = selettore.quantity === 0;
			} else {
				selettore.disableAdd = selettore.power >= delta || this.totalSelettoriOld === this.maxSelettoriOld;
				selettore.disableRemove = selettore.quantity === 0;
			}
		}

		this.totalLoadBusPercentage = Math.floor(this.totalPower / this.maxPower * 100);
		this.totalLoadBoardPercentage = Math.floor(this.totalBoard / this.maxPower * 100);
		this.totalLoadGatewayPercentage = Math.floor(this.totalLoadGateway / this.maxPower * 100);
		this.totalLoadSchedePercentage = Math.floor(this.totalLoadSchede / this.maxPower * 100);
		this.totalLoadFotocelluleBusPercentage = Math.floor(this.totalLoadFotocelluleBus / this.maxPower * 100);
		this.totalLoadSelettoriBusPercentage = Math.floor(this.totalLoadSelettoriBus / this.maxPower * 100);
		this.totalLoadInterfaccieBusPercentage = Math.floor(this.totalLoadInterfaccieBus / this.maxPower * 100);
		this.totalLoadLampeggiantiBusPercentage = Math.floor(this.totalLoadLampeggiantiBus / this.maxPower * 100);
		this.totalLoadFotocelluleOldPercentage = Math.floor(this.totalLoadFotocelluleOld / this.maxPower * 100);
		this.totalLoadSelettoriOldPercentage = Math.floor(this.totalLoadSelettoriOld / this.maxPower * 100);
		this.elaborateGraphic();
	}

	elaborateGraphic(): void {

		const doughnutChartLabels = [this.translate.instant('BUS_PANEL') + ' (' + this.totalBoard + '): ' + this.totalLoadBoardPercentage + '%'];
		const backgroundColor = ['black'];
		const arrayDataSet = [this.totalLoadBoardPercentage];
		if (this.busSelect.maxGateway > 0) {
			doughnutChartLabels.push(this.translate.instant('GATEWAY') + ' (' + this.totalGateway + '): ' + this.totalLoadGatewayPercentage + '%');
			backgroundColor.push('red');
			arrayDataSet.push(this.totalLoadGatewayPercentage);
		}
		if (this.busSelect.maxSchede > 0) {
			doughnutChartLabels.push(this.translate.instant('BUS_BOARD') + ' (' + this.totalSchede + '): ' + this.totalLoadSchedePercentage + '%');
			backgroundColor.push('purple');
			arrayDataSet.push(this.totalLoadSchedePercentage);
		}
		if (this.busSelect.maxSelettoriBus > 0) {
			doughnutChartLabels.push(this.translate.instant('BUS_SELECTORS_BUS') + ' (' + this.totalSelettoriBus + '): ' + this.totalLoadSelettoriBusPercentage + '%');
			backgroundColor.push('orange');
			arrayDataSet.push(this.totalLoadFotocelluleBusPercentage);
		}
		if (this.busSelect.maxFotocelluleBus > 0) {
			doughnutChartLabels.push(this.translate.instant('BUS_PHOTOCELLS_BUS') + ' (' + this.totalFotocelluleBus + '): ' + this.totalLoadFotocelluleBusPercentage + '%');
			backgroundColor.push('green');
			arrayDataSet.push(this.totalLoadSelettoriBusPercentage);
		}
		if (this.busSelect.maxInterfaccieBus > 0) {
			doughnutChartLabels.push(this.translate.instant('BUS_INTERFACES_BUS') + ' (' + this.totalInterfaccieBus + '): ' + this.totalLoadInterfaccieBusPercentage + '%');
			backgroundColor.push('blue');
			arrayDataSet.push(this.totalLoadInterfaccieBusPercentage);
		}
		if (this.busSelect.maxLampeggiantiBus > 0) {
			doughnutChartLabels.push(this.translate.instant('BUS_FLASHING_BUS') + ' (' + this.totalLampeggiantiBus + '): ' + this.totalLoadLampeggiantiBusPercentage + '%');
			backgroundColor.push('pink');
			arrayDataSet.push(this.totalLoadLampeggiantiBusPercentage);
		}
		if (this.busSelect.maxSelettoriOld > 0) {
			doughnutChartLabels.push(this.translate.instant('BUS_SELECTORS') + ' (' + this.totalSelettoriOld + '): ' + this.totalLoadSelettoriOldPercentage + '%');
			backgroundColor.push('orange');
			arrayDataSet.push(this.totalLoadSelettoriOldPercentage);
		}
		if (this.busSelect.maxFotocelluleOld > 0) {
			doughnutChartLabels.push(this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalFotocelluleOld + '): ' + this.totalLoadFotocelluleOldPercentage + '%');
			backgroundColor.push('green');
			arrayDataSet.push(this.totalLoadFotocelluleOldPercentage);
		}
		doughnutChartLabels.push(this.translate.instant('BUS_AVAILABLE') + ': ' + 100 + '%');
		backgroundColor.push('grey');
		const delta = 100 - this.totalLoadBusPercentage;
		arrayDataSet.push(delta);
		// eslint-disable-next-line max-len

		this.totalChart = {
			labels: doughnutChartLabels,
			datasets: [
				{
					data: arrayDataSet,
					backgroundColor: backgroundColor,
					borderWidth: 0,
				},
			],
		};

		this.valuePower = [
			{ color: '#34d399', value: 16 },
			{ color: '#fbbf24', value: 8 },
			{ color: '#60a5fa', value: 24 },
			{ color: '#c084fc', value: 10 }
		];
		this.valueGreenPower = [
			{ color: '#34d399', value: 16 },
			{ color: '#fbbf24', value: 8 },
			{ color: '#60a5fa', value: 24 },
			{ color: '#c084fc', value: 10 }
		];
		this.valueCalcPower = [
			{ color: '#34d399', value: 16 },
			{ color: '#fbbf24', value: 8 },
			{ color: '#60a5fa', value: 24 },
			{ color: '#c084fc', value: 10 }
		];
		/*this.totalChart = {
			datasets: [
				{
					data: arrayDataSet,
					backgroundColor: ['orange', 'green', 'blue', 'pink', 'grey'],
					borderWidth: 0,
				},
			],
		};*/
		/* this.doughnutChartData=  [arrayDataSet];
		this.changeLegends();*/
	}

	canAddAlertVisibleDevice(device: AccessoryPower): string {
		if (this.enableGreenPower && device.limitGreenPower > 0 && this.maxPower < 1) {
			return 'text-green-600';
		}
		if (device.power + this.totalPower > this.maxPower) {
			return 'text-50';
		} if (this.enableGreenPower && device.power + this.totalPower <= this.maxPower) {
			return 'text-green-600';
		}
		return '';
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-25rem');
	}

	col3Responsive(): string {
		return StandardPageLayout.col3ResponsiveStd(this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6ResponsiveDesktopTablet(this.screenWidth);
	}

}
